import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import StripeCheckout from 'react-stripe-checkout';
import InvoicePayment from './InvoicePayment';
import InvoiceView from './InvoiceView';

@inject('userStore')
@withRouter
@observer
class InvoiceTableRow extends Component {
    constructor(props){
        super(props);
        this.state = {
          invoice:null
        }
    }

    componentDidMount(){
      this.setState({
        invoice:this.props.invoice
      })
    }

    //
    // onToken = (token) => {
    //   post('v2/post/stripe_payment_process', {stripe:token, hash_id:this.state.invoice.hash_id, bk_payment_hash_id:this.state.invoice.bk_payment_hash_id}, {
    //           auth: {username: this.props.userStore.token}
    //       }).then((res) => {
    //         if (res.data.errors === 0){
    //             this.setState({
    //                 invoice:res.data.invoice
    //             })
    //         }
    //     }).catch((error) => {
    //           return error;
    //     });
    //
    //
    //   console.log(token, this.props.invoice);
    // }

    render() {
        const {invoice, modalHandler, event} = this.props;
        // const {invoice} = this.state;
        // if (!invoice) return <tr><td colSpan="4">Loading row</td></tr>;
        return (
            <tr>
                <th scope="row">{invoice.invoice_number}</th>
                <td>{invoice.description}</td>
                <td><span className={invoice.is_paid ? "badge badge-success" : "badge badge-danger"}>${invoice.due_amount} - {invoice.is_paid ? "PAID": "DUE"}</span></td>
                <td>
                  <div className="btn-group pull-right">
                    <button className="btn btn-xs btn-primary" onClick={()=>modalHandler(invoice, InvoiceView, event)}><i className="fa fa-search"></i>View</button>
                    {!invoice.is_paid ?
                    <button className="btn btn-xs btn-info" onClick={()=>modalHandler(invoice, InvoicePayment, event)}><i className="fa fa-money"></i> Pay</button>
                    :null}
                  </div>
                </td>
            </tr>
    );}
}


export default InvoiceTableRow;



// WEBPACK FOOTER //
// ./src/components/client/InvoiceTableRow.js